var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "a-drawer",
    {
      staticStyle: {
        height: "100%",
        overflow: "auto",
        "padding-bottom": "53px"
      },
      attrs: {
        title: _vm.title,
        maskClosable: false,
        width: _vm.drawerWidth,
        placement: "right",
        closable: true,
        visible: _vm.visible
      },
      on: { close: _vm.handleCancel }
    },
    [
      _c("template", { slot: "title" }, [
        _c("div", { staticStyle: { width: "100%" } }, [
          _c("span", [_vm._v(_vm._s(_vm.title))]),
          _c(
            "span",
            {
              staticStyle: {
                display: "inline-block",
                width: "calc(100% - 51px)",
                "padding-right": "10px",
                "text-align": "right"
              }
            },
            [
              _c("a-button", {
                staticStyle: { height: "20px", width: "20px", border: "0px" },
                attrs: { icon: "appstore" },
                on: { click: _vm.toggleScreen }
              })
            ],
            1
          )
        ])
      ]),
      _c(
        "a-spin",
        { attrs: { spinning: _vm.confirmLoading } },
        [
          _c(
            "a-form-model",
            {
              ref: "form",
              attrs: { model: _vm.model, rules: _vm.validatorRules }
            },
            [
              _c(
                "a-form-model-item",
                {
                  attrs: {
                    label: "用户账号",
                    labelCol: _vm.labelCol,
                    wrapperCol: _vm.wrapperCol,
                    prop: "username"
                  }
                },
                [
                  _c("a-input", {
                    attrs: {
                      placeholder: "请输入用户账号",
                      disabled: _vm.disableSubmit
                    },
                    model: {
                      value: _vm.model.username,
                      callback: function($$v) {
                        _vm.$set(_vm.model, "username", $$v)
                      },
                      expression: "model.username"
                    }
                  })
                ],
                1
              ),
              _c(
                "a-form-model-item",
                {
                  attrs: {
                    label: "用户姓名",
                    labelCol: _vm.labelCol,
                    wrapperCol: _vm.wrapperCol,
                    prop: "realname"
                  }
                },
                [
                  _c("a-input", {
                    attrs: {
                      placeholder: "请输入用户姓名",
                      disabled: _vm.disableSubmit
                    },
                    model: {
                      value: _vm.model.realname,
                      callback: function($$v) {
                        _vm.$set(_vm.model, "realname", $$v)
                      },
                      expression: "model.realname"
                    }
                  })
                ],
                1
              ),
              _c(
                "a-form-model-item",
                {
                  attrs: {
                    label: "工号",
                    labelCol: _vm.labelCol,
                    wrapperCol: _vm.wrapperCol,
                    prop: "workNo"
                  }
                },
                [
                  _c("a-input", {
                    attrs: {
                      placeholder: "请输入工号",
                      disabled: _vm.disableSubmit
                    },
                    model: {
                      value: _vm.model.workNo,
                      callback: function($$v) {
                        _vm.$set(_vm.model, "workNo", $$v)
                      },
                      expression: "model.workNo"
                    }
                  })
                ],
                1
              ),
              _c(
                "a-form-model-item",
                {
                  directives: [
                    {
                      name: "show",
                      rawName: "v-show",
                      value: !_vm.roleDisabled,
                      expression: "!roleDisabled"
                    }
                  ],
                  attrs: {
                    label: "角色分配",
                    labelCol: _vm.labelCol,
                    wrapperCol: _vm.wrapperCol
                  }
                },
                [
                  _c("j-multi-select-tag", {
                    attrs: {
                      disabled: _vm.disableSubmit,
                      options: _vm.rolesOptions,
                      placeholder: "请选择角色"
                    },
                    model: {
                      value: _vm.model.selectedroles,
                      callback: function($$v) {
                        _vm.$set(_vm.model, "selectedroles", $$v)
                      },
                      expression: "model.selectedroles"
                    }
                  })
                ],
                1
              ),
              _c(
                "a-form-model-item",
                {
                  directives: [
                    {
                      name: "show",
                      rawName: "v-show",
                      value: !_vm.departDisabled,
                      expression: "!departDisabled"
                    }
                  ],
                  attrs: {
                    label: "部门分配",
                    labelCol: _vm.labelCol,
                    wrapperCol: _vm.wrapperCol
                  }
                },
                [
                  _c(
                    "j-select-depart",
                    {
                      attrs: {
                        disabled: _vm.disableSubmit,
                        multi: true,
                        backDepart: true,
                        treeOpera: true
                      },
                      on: { back: _vm.backDepartInfo },
                      model: {
                        value: _vm.model.selecteddeparts,
                        callback: function($$v) {
                          _vm.$set(_vm.model, "selecteddeparts", $$v)
                        },
                        expression: "model.selecteddeparts"
                      }
                    },
                    [_vm._v(">")]
                  )
                ],
                1
              ),
              _c(
                "a-form-model-item",
                {
                  attrs: {
                    label: "申请使用应用",
                    prop: "selectedApplications",
                    labelCol: _vm.labelCol,
                    wrapperCol: _vm.wrapperCol
                  }
                },
                [
                  _c("j-multi-select-tag", {
                    attrs: {
                      disabled: _vm.disableSubmit,
                      options: _vm.applicationOptions,
                      placeholder: "请选择应用"
                    },
                    model: {
                      value: _vm.model.selectedApplications,
                      callback: function($$v) {
                        _vm.$set(_vm.model, "selectedApplications", $$v)
                      },
                      expression: "model.selectedApplications"
                    }
                  })
                ],
                1
              ),
              _c(
                "a-form-model-item",
                {
                  attrs: {
                    label: "身份",
                    labelCol: _vm.labelCol,
                    wrapperCol: _vm.wrapperCol
                  }
                },
                [
                  _c(
                    "a-radio-group",
                    {
                      attrs: { disabled: _vm.disableSubmit },
                      on: { change: _vm.identityChange },
                      model: {
                        value: _vm.model.userIdentity,
                        callback: function($$v) {
                          _vm.$set(_vm.model, "userIdentity", $$v)
                        },
                        expression: "model.userIdentity"
                      }
                    },
                    [
                      _c("a-radio", { attrs: { value: 1 } }, [
                        _vm._v("普通用户")
                      ]),
                      _c("a-radio", { attrs: { value: 2 } }, [_vm._v("上级")])
                    ],
                    1
                  )
                ],
                1
              ),
              _vm.departIdShow == true
                ? _c(
                    "a-form-model-item",
                    {
                      attrs: {
                        label: "负责部门",
                        labelCol: _vm.labelCol,
                        wrapperCol: _vm.wrapperCol
                      }
                    },
                    [
                      _c("j-multi-select-tag", {
                        attrs: {
                          disabled: _vm.disableSubmit,
                          options: _vm.nextDepartOptions,
                          placeholder: "请选择负责部门"
                        },
                        model: {
                          value: _vm.model.departIds,
                          callback: function($$v) {
                            _vm.$set(_vm.model, "departIds", $$v)
                          },
                          expression: "model.departIds"
                        }
                      })
                    ],
                    1
                  )
                : _vm._e(),
              _c(
                "a-form-model-item",
                {
                  attrs: {
                    label: "头像",
                    labelCol: _vm.labelCol,
                    wrapperCol: _vm.wrapperCol
                  }
                },
                [
                  _c("j-image-upload", {
                    staticClass: "avatar-uploader",
                    attrs: { text: "上传" },
                    model: {
                      value: _vm.model.avatar,
                      callback: function($$v) {
                        _vm.$set(_vm.model, "avatar", $$v)
                      },
                      expression: "model.avatar"
                    }
                  })
                ],
                1
              ),
              _c(
                "a-form-model-item",
                {
                  attrs: {
                    label: "生日",
                    labelCol: _vm.labelCol,
                    wrapperCol: _vm.wrapperCol
                  }
                },
                [
                  _c("a-date-picker", {
                    staticStyle: { width: "100%" },
                    attrs: {
                      disabled: _vm.disableSubmit,
                      placeholder: "请选择生日",
                      format: _vm.dateFormat,
                      getCalendarContainer: function(node) {
                        return node.parentNode
                      }
                    },
                    model: {
                      value: _vm.model.birthday,
                      callback: function($$v) {
                        _vm.$set(_vm.model, "birthday", $$v)
                      },
                      expression: "model.birthday"
                    }
                  })
                ],
                1
              ),
              _c(
                "a-form-model-item",
                {
                  attrs: {
                    label: "性别",
                    labelCol: _vm.labelCol,
                    wrapperCol: _vm.wrapperCol
                  }
                },
                [
                  _c(
                    "a-select",
                    {
                      attrs: {
                        disabled: _vm.disableSubmit,
                        placeholder: "请选择性别",
                        getPopupContainer: function(target) {
                          return target.parentNode
                        }
                      },
                      model: {
                        value: _vm.model.sex,
                        callback: function($$v) {
                          _vm.$set(_vm.model, "sex", $$v)
                        },
                        expression: "model.sex"
                      }
                    },
                    [
                      _c("a-select-option", { attrs: { value: 1 } }, [
                        _vm._v("男")
                      ]),
                      _c("a-select-option", { attrs: { value: 2 } }, [
                        _vm._v("女")
                      ])
                    ],
                    1
                  )
                ],
                1
              ),
              _c(
                "a-form-model-item",
                {
                  attrs: {
                    label: "邮箱",
                    labelCol: _vm.labelCol,
                    wrapperCol: _vm.wrapperCol,
                    prop: "email"
                  }
                },
                [
                  _c("a-input", {
                    attrs: {
                      placeholder: "请输入邮箱",
                      disabled: _vm.disableSubmit
                    },
                    model: {
                      value: _vm.model.email,
                      callback: function($$v) {
                        _vm.$set(_vm.model, "email", $$v)
                      },
                      expression: "model.email"
                    }
                  })
                ],
                1
              ),
              _c(
                "a-form-model-item",
                {
                  attrs: {
                    label: "手机号码",
                    labelCol: _vm.labelCol,
                    wrapperCol: _vm.wrapperCol,
                    prop: "phone"
                  }
                },
                [
                  _c("a-input", {
                    attrs: {
                      placeholder: "请输入手机号码",
                      disabled: _vm.disableSubmit
                    },
                    model: {
                      value: _vm.model.phone,
                      callback: function($$v) {
                        _vm.$set(_vm.model, "phone", $$v)
                      },
                      expression: "model.phone"
                    }
                  })
                ],
                1
              ),
              _c(
                "a-form-model-item",
                {
                  attrs: {
                    label: "座机",
                    labelCol: _vm.labelCol,
                    wrapperCol: _vm.wrapperCol,
                    prop: "telephone"
                  }
                },
                [
                  _c("a-input", {
                    attrs: {
                      placeholder: "请输入座机",
                      disabled: _vm.disableSubmit
                    },
                    model: {
                      value: _vm.model.telephone,
                      callback: function($$v) {
                        _vm.$set(_vm.model, "telephone", $$v)
                      },
                      expression: "model.telephone"
                    }
                  })
                ],
                1
              ),
              _c(
                "a-form-model-item",
                {
                  attrs: {
                    label: "审核意见",
                    labelCol: _vm.labelCol,
                    wrapperCol: _vm.wrapperCol,
                    prop: "auditRemark"
                  }
                },
                [
                  _c("a-textarea", {
                    attrs: {
                      placeholder: "请输入审核意见",
                      "max-Length": "500"
                    },
                    model: {
                      value: _vm.model.auditRemark,
                      callback: function($$v) {
                        _vm.$set(_vm.model, "auditRemark", $$v)
                      },
                      expression: "model.auditRemark"
                    }
                  })
                ],
                1
              )
            ],
            1
          )
        ],
        1
      ),
      _c(
        "div",
        {
          directives: [
            {
              name: "show",
              rawName: "v-show",
              value: !_vm.auditFlag,
              expression: "!auditFlag"
            }
          ],
          staticClass: "drawer-bootom-button"
        },
        [
          _c("a-button", { on: { click: _vm.reject } }, [_vm._v("拒绝")]),
          _c(
            "a-popconfirm",
            {
              attrs: {
                title: "确定通过申请吗？",
                okText: "确定",
                cancelText: "取消"
              },
              on: { confirm: _vm.pass }
            },
            [
              _c(
                "a-button",
                {
                  staticStyle: { margin: "0px 10px" },
                  attrs: { type: "primary" }
                },
                [_vm._v("通过")]
              )
            ],
            1
          )
        ],
        1
      )
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }